<template>
  <base-accordion :title="apiData.label" :title-code="apiData.code">
    <div class="inline-flex flex-wrap px-3 py-1 mx-2 mt-3 text-sm leading-snug rounded-sm bg-yellow text-darkblue info" v-if="apiData.capacities.length > 0">
      <div class="mr-4" v-for="(capacity, index) in apiData.capacities" :key="index">
        <strong>{{ capacity.label }}</strong>
      </div>
    </div>
    <div class="flex flex-wrap">
      <base-product v-for="item in apiData.use[0].products" :itemData="item" :key="item.code" class="w-1/2 md:w-1/3 xl:w-1/4 2xl:w-1/5 3xl:w-1/6" :class="{ 'w-full md:w-full xl:w-full 2xl:w-full 3xl:w-full': !item.fromDB }" />
    </div>
  </base-accordion>
</template>

<script>
import BaseProduct from '@/components/BaseProduct.vue';
import BaseAccordion from '@/components/BaseAccordion.vue';

export default {
  props: {
    apiData: {
      required: true,
      type: Object
    }
  },
  components: {
    BaseProduct,
    BaseAccordion
  }
};
</script>

<style lang="scss" scoped></style>
